import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import OnboardingStepEvent from "../event/OnboardingStepEvent";
import OnboardingModel from "../model/OnboardingModel";

export default class OnboardingStepCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {OnboardingModel} onboardingModel 
     */
    constructor(dispatcher, onboardingModel) {
        super(dispatcher);

        this._onboardingModel = onboardingModel;

        this._finishOnboardingStepBound = this._finishOnboardingStep.bind(this);
    }

    execute(evt) {
        /** @type {OnboardingStepEvent} */
        const data = evt.params.data;
        this._stepId = data.stepId;

        switch (data.type) {
            case OnboardingStepEvent.SHOW_ONBOARDING_STEP:
                this._showOnboardingStepIfNotSeen(data.stepId);
                break;
        }
    }

    _showOnboardingStepIfNotSeen(stepId) {
        if (this._onboardingModel.hasSeenOnboarding(stepId)) {
            // Directly dispatch the finish event, so it will be considered as finished directly.
            const onboardingStepEvent = new OnboardingStepEvent(OnboardingStepEvent.FINISH_ONBOARDING_STEP, stepId);
            this.dispatch(onboardingStepEvent.type, { data: onboardingStepEvent });
            return;
        }

        this._showOnboardingStep(stepId);
    }

    _showOnboardingStep(stepId) {
        this._dispatcher.addEventListener(OnboardingStepEvent.FINISH_ONBOARDING_STEP, this._finishOnboardingStepBound);

        this._onboardingStepScreenSkin = this.openScreen(SkinKeyRegistry.ONBOARDING_STEP_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            stepId,
        });
    }

    _finishOnboardingStep(evt) {
        /** @type {OnboardingStepEvent} */
        const data = evt.params.data;
        if (this._stepId !== data.stepId) {
            return;
        }

        this._dispatcher.removeEventListener(OnboardingStepEvent.FINISH_ONBOARDING_STEP, this._finishOnboardingStepBound);

        this.closeScreen(this._onboardingStepScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._onboardingModel.markOnboardingAsSeen(this._stepId);
    }
}